import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PHBHPFeaturePackageConsumptionService } from './../ph-bhp-feature-package-consumption.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ConsumptionPeriod, Consumption } from '../Models/Consumption';
import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-year-consumption',
  templateUrl: './ph-bhp-year-consumption.component.html',
  styleUrls: ['./ph-bhp-year-consumption.component.css']
})
export class PhBhpYearConsumptionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isMilliliter = true;
  isLiter = true;
  viewFlag: string = 'liter';
  periodInYearForm: UntypedFormGroup;
  consumptionJsonData;
  consumptionID: number;
  providerNumber: 1;
  haiOccurrences: number;
  haiEnabled: boolean = false;
  consumptionData: Array<Consumption> = [];
  consumptionPeriodData: Array<ConsumptionPeriod> = [];
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  consumptionConfigDetail: Array<any> = [];
  inputData: Array<any> = [];
  isSaving: boolean = false;
  @Input() userData;
  @Input() formdata;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(private service: PHBHPFeaturePackageConsumptionService, public appConfig: AppConfig, private router: Router, private activatedRoute: ActivatedRoute, private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.getConsumptionConfigByInstitutionIdList();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id;
      this.getConsumptionConfigByInstitutionIdList();
    });

    this.periodInYearForm = new UntypedFormGroup({
      consumptionValue: new UntypedFormControl("", Validators.compose([Validators.required])),
      patientDays: new UntypedFormControl("", Validators.compose([Validators.required])),
      periodNumber: new UntypedFormControl("", Validators.compose([Validators.required])),
      haiOccurrences: new UntypedFormControl("")
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  amountMeasure() {
    if (this.consumptionYearConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (this.consumptionYearConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure() {
    if (this.consumptionYearConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
    } else if (this.consumptionYearConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('CONSUMPTION.AMOUNT.IN_MILLILITERS');
    }
  }

  getConsumptionConfigByInstitutionIdList() {
    this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res: Array<any> = []) => {
      this.consumptionConfigDetail[0] = res;
      this.consumptionYearConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail[0].consumptionConfigs, this.formdata.year)
      this.haiEnabled = this.consumptionConfigDetail[0].enableHAITracking;
    });
  }

  cancelConsupmtionPeriod() {
    this.appConfig.showconsumption = false;
    this.router.navigate(['/consumption/new']);
  }

  saveConsumptionPeriod() {
    this.convertCommaToDot();
    var formValue1: Boolean = false;
    var consumptionValueFlag: Boolean = false;
    var patientDaysFlag: Boolean = false;

    if (this.periodInYearForm.value.consumptionValue == null) {
      this.periodInYearForm.value.consumptionValue = "";
    }
    if (this.periodInYearForm.value.patientDays == null || this.periodInYearForm.value.patientDays == 0) {
      this.periodInYearForm.value.patientDays = "";
    }
    if (!this.haiEnabled || (this.haiEnabled && (this.periodInYearForm.value.haiOccurrences == null || this.periodInYearForm.value.haiOccurrences == 0))) {
      this.periodInYearForm.value.haiOccurrences = "";
    }

    if (this.periodInYearForm.value.consumptionValue != "" && this.periodInYearForm.value.patientDays == "") {
      patientDaysFlag = true;
    } else if (this.periodInYearForm.value.consumptionValue == "" && this.periodInYearForm.value.patientDays != "") {
      consumptionValueFlag = true;
    } else if (this.periodInYearForm.value.consumptionValue != "" && this.periodInYearForm.value.patientDays != "") {
      formValue1 = true;
    }


    if (patientDaysFlag) {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PATIENT_DAYS"));
    } else if (consumptionValueFlag) {
      if (this.consumptionYearConfiguration.amountMeasured == "u") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_USED_DATA"));
      } else if (this.consumptionYearConfiguration.amountMeasured == "p") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PURCHASED_DATA"));
      }
    } else if (formValue1) {
      this.SaveNewConsumption()
    } else {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.NO_CHANGES_TO_SAVE"));
    }
  }

  convertCommaToDot() {
    this.periodInYearForm.value.consumptionValue = this.periodInYearForm.value.consumptionValue.toString().replace(',', '.');
  }

  SaveNewConsumption() {
    if (this.isSaving) return;
    this.isSaving = true;
    var data = {
      period: this.consumptionYearConfiguration.period.toLowerCase(),
      wardID: this.formdata.wardID.wardID,
      departmentID: this.formdata.departmentID.departmentID,
      departmentTypeID: this.formdata.wardID.departmentTypeID,
      year: this.formdata.year,
      institutionID: this.layoutService.institutionID,
      createdBy: this.userData.userId,
      consumptionPeriodID: null
    }

    this.service.createConsumption(data).subscribe((res: any) => {
      this.consumptionID = res.consumptionID;
      this.inputData = [{
        consumptionID: this.consumptionID,
        consumptionValue: this.periodInYearForm.value.consumptionValue,
        patientDays: this.periodInYearForm.value.patientDays,
        haiOccurrences: this.periodInYearForm.value.haiOccurrences ? this.periodInYearForm.value.haiOccurrences : null,
        periodNumber: 1
      }]

      this.service.createConsumptionPeriod(this.inputData).subscribe({
        next: res => {
          // this.layoutService.showSuccess(this.layoutService.translateText('CONSUMPTION.CONSUMPTION.SUCCESSFULLY_ADDED_DETAILS'));
        },
        error: err => {

        },
        complete: () => {
          this.router.navigate(['/consumption/past']);
        }
      })
    });
  }

  isLiters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'l';
  }

  isMilliliters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'm';
  }
}
